<template>
  <!--查看-->
  <div>
    <el-form :model="formData" :rules="rules" v-loading="saveLoading" ref="integrateAddForm" size="mini" :label-width="'160px'" class="form-horizontal detail-form paddingTopDetail employeeEditDetail" >
      <el-form-item prop="qxyy" label="取消原因：" class="rowItem">
        <el-input type="textarea" :rows="3" v-model="formData.qxyy" placeholder="请输入" ></el-input>
      </el-form-item>
      <div style="text-align: center;padding: 20px;width: 100%;">
        <el-button class="primary-btn-g" icon="CircleCheck"  @click="handleSave(0)" >取消订单</el-button>
        <el-button class="warning-btn-g" icon="CircleClose" @click="handleCancel">关闭</el-button>
      </div>

    </el-form>
  </div>
</template>

<script>
  import RichText from "@/components/common/RichText/RichText";
  import {
    mapActions
  } from 'vuex'
  import moment from 'moment'
  export default {
    components: {RichText},
    name: "orderCancelModel",
      props:{
        selOptions: {
          type: Object,
          default:{wyfbm:[],ydrGjdm:[],ydrCyzjdm:[]},
        },
        detailModal:{
          type:Boolean,
          default:''
        },
        detailData:{
          type:Object,
          default:{}
        },
        detailType:{
          type:String,
          default:'show'
        }
      },
      data(){
        let detailKeys = ['wyfbm','ydrXm','ydrGjdm','ydrCyzjdm','ydrZjhm','ydrWwx', 'ydrWwm','ydrLxdh','ydrNc','ydrzrq','nlkrq','messageNote','delayed','xdsj','ddbm','orderState','qxyy']

        let formData = {}
        detailKeys.map((key)=>{
          formData[key] = ''
        })
        return{
          isValid:true,
          showType:'',
          saveLoading:false,
          detailKeys:detailKeys,

          rules:{
          },

          wyfdzSsxqdm_provinceDicts:[],
          wyfdzSsxqdm_cityDicts:[],
          wyfdzSsxqdm_areaDicts:[],
          areaCodes:{},
          formData:formData
        }
    },
    created(){
    },
    mounted(){
      this.showType = this.detailType
    },
    watch:{
      detailType(val){
        this.showType = val
      },
      detailModal:{
        immediate: true,
        handler: function(to){
          if(to===false){
            return false
          }/*该操作是不可恢复的，是否取消订单!*/
          this.formData.qxyy = ''
        }
      }
    },
    methods:{
      ...mapActions([
        'alertToggle',
        'fetchData'
      ]),
      //保存与发布
      handleSave(type){
        //this.saveLoading = true
        this.$confirm('该操作是不可恢复的，是否取消订单?', { type: 'warning' })
          .then(() => {
            this.doSave('cancel')
          })
          .catch(() => false)

      },
      doSave(type){

        let url = 'SAAS.ORDER_CANCEL'
        let paramData = {...this.detailData}
        paramData.qxsj = moment().format('YYYY-MM-DD HH:mm:ss')
        paramData.qxyy = this.formData.qxyy
        paramData.orderState = 0

        let params = {params:JSON.stringify(paramData)}

        this.fetchData({url:url, method: 'post', params:params,timeout:0, isLoading:false, flag:true}).then((res)=>{
          if(res.status==1){
            this.$message.success(res.msg||'操作成功！')
            this.$emit('submitSuccess')
          }else{
            this.$message.error(res.msg||'操作失败！')
          }
          this.saveLoading = false
        }).catch((err)=>{
          this.$message.error('操作失败！')
          this.saveLoading = false
        }).finally (()=>{
          this.saveLoading = false
        })
      },
      handleCancel(){
        this.$emit('closeModel')
      },
    },
  }
</script>

<style lang="less" scoped>
  .employeeEditDetail{
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    width: 90% !important;
  }
  .employeeEditDetail .el-form-item{
    width: 50% !important;
    .el-select{
      width: 100%;
    }
  }
  .employeeEditDetail .el-form-item.rowItem {
    width: 100% !important;
  }
  .employeeEditDetail .detailContent{
    padding: 0px;
  }
  .sentContent{
    margin: 20px;
    padding: 10px;
    border: 1px solid rgba(38, 118, 165, 1) ;
  }
  .sentContentTitle{
    text-align: center;
  }


</style>
<style lang="less" >
  .employeeEditDetail .w-e-text-container{
    border:1px solid #2676a5 !important;
  }
</style>

